<div class="flex flex-col gap-4">

    <!-- Toolbar -->
    <div class="bg-gray-100 border border-gray-300 rounded-t p-2 flex flex-wrap items-center gap-1">

        <!-- Formatting buttons -->
        @for (action of toolbarActions; track action.command) {
        <button type="button" (click)="execCommand(action.command, action.value)"
            [title]="action.title"
            class="w-8 h-8 flex items-center justify-center rounded hover:bg-gray-200 text-gray-700">
            <i [class]="action.icon"></i>
        </button>
        }

        <span class="w-px h-6 bg-gray-300 mx-1"></span>

        <!-- Font size -->
        <select (change)="changeFontSize($any($event.target).value)"
            class="text-xs border border-gray-300 rounded px-1 py-1 bg-white">
            <option value="" disabled selected>Taille</option>
            @for (size of fontSizes; track size) {
            <option [value]="size">{{ size }}</option>
            }
        </select>

        <span class="w-px h-6 bg-gray-300 mx-1"></span>

        <!-- Text color -->
        <div class="flex items-center gap-0.5">
            <span class="text-xs text-gray-500 mr-1">A</span>
            @for (color of colors; track color) {
            <button type="button" (click)="changeColor(color)"
                class="w-5 h-5 rounded border border-gray-300 cursor-pointer"
                [style.backgroundColor]="color"
                [title]="'Couleur: ' + color">
            </button>
            }
        </div>

        <span class="w-px h-6 bg-gray-300 mx-1"></span>

        <!-- Placeholders dropdown -->
        <div class="relative inline-block">
            <select (change)="insertPlaceholder(availablePlaceholders[$any($event.target).selectedIndex - 1]); $any($event.target).selectedIndex = 0;"
                class="text-xs border border-blue-300 bg-blue-50 rounded px-2 py-1">
                <option disabled selected>+ Insérer champ</option>
                @for (ph of availablePlaceholders; track ph.key) {
                <option>{{ ph.label }} {{ ph.type === 'image' ? '(image)' : '' }}</option>
                }
            </select>
        </div>

        <span class="w-px h-6 bg-gray-300 mx-1"></span>

        <!-- Actions -->
        <button type="button" (click)="toggleSourceView()"
            class="text-xs px-2 py-1 rounded border"
            [class]="showSourceCode ? 'bg-yellow-100 border-yellow-400 text-yellow-800' : 'bg-white border-gray-300 text-gray-600 hover:bg-gray-100'"
            title="Vue source HTML">
            <i class="fas fa-code"></i>
        </button>

        <button type="button" (click)="togglePreview()"
            class="text-xs px-2 py-1 rounded border"
            [class]="showPreview ? 'bg-green-100 border-green-400 text-green-800' : 'bg-white border-gray-300 text-gray-600 hover:bg-gray-100'"
            title="Aperçu badge">
            <i class="fas fa-eye"></i>
        </button>

        <button type="button" (click)="loadDefaultTemplate()"
            class="text-xs px-2 py-1 rounded border bg-white border-gray-300 text-gray-600 hover:bg-gray-100"
            title="Template par défaut">
            <i class="fas fa-magic"></i>
        </button>
    </div>

    <!-- Editor area -->
    @if (!showSourceCode) {
    <div #editorArea contenteditable="true"
        (input)="onEditorInput()"
        class="min-h-[200px] border border-gray-300 border-t-0 rounded-b p-4 bg-white focus:outline-none focus:ring-2 focus:ring-blue-200">
    </div>
    } @else {
    <!-- Source code view -->
    <textarea [(ngModel)]="sourceHtml"
        (input)="onSourceChange()"
        class="min-h-[200px] border border-gray-300 border-t-0 rounded-b p-4 bg-gray-50 font-mono text-xs focus:outline-none focus:ring-2 focus:ring-yellow-200"
        [style.minHeight.px]="badgeHeight">
    </textarea>
    }

    <!-- Preview panel -->
    @if (showPreview) {
    <div class="border border-green-300 rounded p-4 bg-green-50">
        <h5 class="text-sm font-medium text-green-800 mb-2">
            <i class="fas fa-eye mr-1"></i> Aperçu du badge
        </h5>
        <app-badge-renderer
            [template]="template"
            [data]="previewData"
            [width]="badgeWidth"
            [height]="badgeHeight">
        </app-badge-renderer>
    </div>
    }

</div>